import { render, staticRenderFns } from "./TransactionLogMessage.vue?vue&type=template&id=aa2f8d3e"
import script from "./TransactionLogMessage.vue?vue&type=script&lang=js"
export * from "./TransactionLogMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports